// extracted by mini-css-extract-plugin
export default {"errorMsg":"ScheduleList_errorMsg__gB0tg"};